import request from './service.js'


// 区域销售占比-左上
export function cmsSysCloudlsdCountCountry() {
    return request({
      url: '/api/cmsSysCloudlsdCountCountry/findAll',
      method: 'get',
    })
  }
//区域销售占比分页查询-第三张原型图查询-暂时与大屏左上共用
  
  export function cmsSysCloudlsdAreaSalesAmountfindAllPage(data) {
    return request({
      url: '/api/cmsSysCloudlsdAreaSalesAmount/findAllPage',
      method: 'post',
      data
    })
  }

//跨境电商数量-左下
export function cmsSysCloudlsdCountEnterprise() {
  return request({
    url: '/api/cmsSysCloudlsdCountEnterprise/findAll',
    method: 'get',
  })
}

//综试区发展指数-中下
export function cmsSysCloudlsdDevelopIndex() {
  return request({
    url: '/api/cmsSysCloudlsdDevelopIndex/findAll',
    method: 'get',
  })
}

//平台数据占比-右上
export function cmsSysCloudlsdCountPlatform() {
  return request({
    url: '/api/cmsSysCloudlsdCountPlatform/findAll',
    method: 'get',
  })
}

  //卖家信息分页查询-第二张原型图查询-暂时与大屏右上共用
  export function cmsSysCloudlsdCountCountryfindAll(data) {
    return request({
      url: '/api/cmsSysCloudlsdSellerInfo/findAllPage',
      method: 'post',
      data
    })
  }


//品类数据-右下
export function cmsSysCloudlsdCountCommodityType() {
  return request({
    url: '/api/cmsSysCloudlsdCountCommodityType/findAll',
    method: 'get',
  })
}
//综试区数量统计-中间
export function findAllAndCount() {
  return request({
    url: '/api/api/cmsSysCloudlsdCountArea/findAllAndCount',
    method: 'get',
  })
}




// 公共大屏-获取销售额统计
// POST /lsdRegionTradeStat/index
// 接口ID：371501600
// 接口地址：https://app.apifox.com/project/780989/apis/api-371501600

export function lsdRegionTradeStatIndex(data) {
  return request({
    url: '/api/lsdRegionTradeStat/index',
    method: 'post',
    data
  })
}






// 公共大屏-获取地区跨境电商数量
// POST /lsdRegionEcommerceStat/index
// 接口ID：372654029
// 接口地址：https://app.apifox.com/project/780989/apis/api-372654029


export function lsdRegionEcommerceStatIndex(data) {
  return request({
    url: '/api/lsdRegionEcommerceStat/index',
    method: 'post',
    data
  })
}

// 大屏登录认证
// POST /cloudLSD/permissions/attest
// 接口ID：358365479
// 接口地址：https://app.apifox.com/project/780989/apis/api-358365479

export function cloudLSDPermissionsAttest(data) {
  return request({
    url: '/api/cloudLSD/permissions/attest',
    method: 'post',
    data
  })
}


//登出
export function cloudLSDPermissionsLogout(data) {
  return request({
    url: '/api/cloudLSD/permissions/logout',
    method: 'post',
    data
  })
}